export const layout = {
    settings: {
        layout_type: "ltr",
        layout: "default",
        sidebar_icon: "stroke-svg",
        sidebar_setting: "compact-wrapper"
    },
    color: {
        layout_version: "light",
        // Bleu du logo ROMAS adouci (logo : #202B87 ; ancienne valeur du thème : #7A70BA, violet)
        primary_color: "#2F4F8F",
        secondary_color: "#48A3D7"
    }
}